import { ref } from 'vue'
import { useStore } from 'vuex'

/** Блокирует UI на время сохранения редактора (кнопка + глобальный прелоадер) */
export function useEditorSave () {
  const store = useStore()
  const isSaving = ref(false)

  const runSave = async (saveFn) => {
    if (isSaving.value) return
    isSaving.value = true
    store.commit('SetBigPreloader', true)
    try {
      await saveFn()
    } finally {
      isSaving.value = false
      store.commit('SetBigPreloader', false)
    }
  }

  return { isSaving, runSave }
}
